import { parseAccesparkResponse } from "../ciclosAccespark/model/accesparkModel";

// Conserva el estado HTTP y el motivo del backend en operaciones de ciclos.
export function cycleRequestError(error, fallback) {
  const response = error.response;
  if (!response) return fallback;
  const body = parseAccesparkResponse(response.data);
  const detail = parseAccesparkResponse(body?.response) || body;
  const message =
    detail?.Message ||
    detail?.message ||
    detail?.detail ||
    body?.message ||
    body?.error ||
    (body?.msm && !/^(successful|succesful)$/i.test(body.msm) ? body.msm : null) ||
    (typeof response.data === "string" && !response.data.trim().startsWith("<")
      ? response.data.trim()
      : null) ||
    response.statusText ||
    "El servidor no informó el motivo del fallo";
  return `HTTP ${response.status}: ${message}. Verifique el historial antes de reintentar la operación.`;
}
